(function() {
      const trigger = document.querySelector('.free-shipping-info-trigger');
      const popup = document.querySelector('.free-shipping-popup');
      const closeBtn = document.querySelector('.free-shipping-popup-close');

      if (trigger && popup && closeBtn) {
        trigger.addEventListener('click', function(e) {
          e.stopPropagation();
          popup.hidden = !popup.hidden;
        });

        closeBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          popup.hidden = true;
        });

        // Close when clicking outside
        document.addEventListener('click', function(e) {
          if (!popup.hidden && !popup.contains(e.target) && !trigger.contains(e.target)) {
            popup.hidden = true;
          }
        });

        // Prevent popup clicks from closing it
        popup.addEventListener('click', function(e) {
          e.stopPropagation();
        });
      }
    })();